import { Component, EventEmitter, Input, Output, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { Flightinfo } from '../models/flightModel';
import { FormService } from '../organizations/features/booking/components/form/service';

@Component({
    selector: 'pf-flight-option',
    imports: [DatePipe, CommonModule],
    templateUrl: './pf-flight-option.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './pf-flight-option.component.scss'
})
export class PfFlightOptionComponent {
  @Input({required : true }) flightInfo! : Flightinfo;
  @Input() time: string = '';
  @Input() codeshares:string[] = [];
  @Input() destination:string = '';
  @Input() isSelected: boolean = false;

  constructor() {
  }

  @Output() flightPickedEvent = new EventEmitter();

  selectFlight(event : any) {

    this.flightPickedEvent.emit(this.flightInfo);
  }

  @Output() selectEvent = new EventEmitter<void>();

  select(): void {
    this.selectEvent.emit();
  }
}
